import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyPhotoArchLayout = loadable(() => import(/* webpackChunkName: "content/guest/header/photoArch" */ './PhotoArch'), 'PhotoArchLayout');
